<template>
  <div class="page-about">
    <header>
      <div class="wrap">
        <div class="logo-wrap">
          <img :src="require(`../../../assets/index/logo.png`)" alt="">
        </div>
        <ul class="nav">
          <li :class="currentNav == 0?'cur':''" @click="toIndex">首页
            <div class="line"></div>
          </li>
          <li :class="currentNav == 1?'cur':''">小布壳
            <div class="line"></div>
            <div class="child-box">
              <div class="item one" @click="toQ1">小布壳Q1</div>
              <div class="item two" @click="toBrand">小布壳品牌</div>
            </div>
          </li>
          <li :class="currentNav == 2?'cur':''" @click="toAbout">关于偶家
            <div class="line"></div>
          </li>
          <li :class="currentNav == 3?'cur':''" @click="toJoin">加入偶家
            <div class="line"></div>
          </li>
        </ul>
      </div>
    </header>
    <div class="box_fixed" id="boxFixed" :class="{'is_fixed' : isFixed}">
      <div class="xbk-nav">
        <ul class="r">
          <li :class="currentxbk == 0?'cur':''">关于偶家</li>
          <li :class="currentxbk == 1?'cur':''" @click="toBootstrap">公益企业</li>
        </ul>
      </div>
    </div>
    <div class="main-wrap">
      <div class="banner">
        <img :src="require(`../../../assets/about/banner.png`)" alt="">
      </div>
      <ul class="about-wrap">
        <li class="w1">
          <img :src="require(`../../../assets/about/bg_1.jpg`)" alt="">
          <div class="w-inner">
            <div class="word-w">
              <div class="title">公司简介</div>
              <div class="detail">
                深圳市偶家科技有限公司(以下简称偶家科技)成立于2016年，于2017年被美国非盈利机构B-Lab认证为共益企业，是一家面向学龄前儿童，提供基于证据的个性化认知教育和智慧教育的高科技公司。通过技术驱动，结合专业阅读内容，为学龄前儿童打造最优质的智能阅读平台。
              </div>
            </div>
            <div class="img-w">
              <img :src="require(`../../../assets/about/img_1.jpg`)" alt="">
            </div>
          </div>
        </li>
        <li class="w2">
          <img :src="require(`../../../assets/about/bg_2.jpg`)" alt="">
          <div class="w-inner">
            <div class="img-w">
              <img :src="require(`../../../assets/about/img_2.jpg`)" alt="">
            </div>
            <div class="word-w">
              <div class="title">品牌故事</div>
              <div class="detail">
                偶家科技刘金晓发现好友四岁的女儿，因为经常和父母做亲子阅读，养成了超乎同龄人的语言组织能力和想象能力，但自己因为工作原因，无法像好友一样时长陪在女儿身边，和她一起阅读。与此同时，他发现社会上很多父母也会遇到和他一样的困扰。为了给女儿带去更多阅读乐趣，也为了让更多的学龄前小朋友在成长的道路上有阅读相伴，刘金晓联合了一群具有相同信念的朋友成立了偶家科技。
              </div>
            </div>            
          </div>
        </li>
        <li class="w3">
          <img :src="require(`../../../assets/about/bg_3.jpg`)" alt="">
          <div class="w-inner">
            <div class="word-w">
              <div class="title">核心人才</div>
              <div class="detail">
                偶家科技由一群心怀共同信仰的理想主义者汇聚而成，其核心团队来自于华为、腾讯、甲骨文以及卡耐基梅隆大学等巨头公司和高等学府，这些在市场、技术、产品、设计等不同领域的顶尖人才，共同努力打造中国最优质的学龄前儿童阅读平台。
              </div>
            </div>
            <div class="img-w">
              <img :src="require(`../../../assets/about/img_3.jpg`)" alt="">
            </div>
          </div>
        </li>
        <li class="w4">
          <el-carousel height="400px" direction="vertical">
            <el-carousel-item>
              <div class="wrap">
                <div class="img-w">
                  <img :src="require(`../../../assets/about/img_4.jpg`)" alt="">
                </div>
                <div class="word-w">
                  <div class="title">核心理念  阅读</div>
                  <div class="detail">
                    偶家科技重视学龄前儿童阅读习惯的培养，积极引导学龄前儿童的阅读兴趣。将AI智能等先进的科技和专业的阅读内容相结合，为学龄前儿童提供更加科学和有趣的阅读体验。
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="wrap">
                <div class="img-w">
                  <img :src="require(`../../../assets/about/img_2.jpg`)" alt="">
                </div>
                <div class="word-w">
                  <div class="title">核心理念 陪伴</div>
                  <div class="detail">
                    孩子成长过程中，父母的陪伴十分重要。偶家科技不断通过新的技术和产品帮助父母探寻与孩子共处的新形式，拓展与孩子共处的新场景，促进亲子间情感交流，帮助孩子更加全面健康地成长。
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="wrap">
                <div class="img-w">
                  <img :src="require(`../../../assets/about/img_5.jpg`)" alt="">
                </div>
                <div class="word-w">
                  <div class="title">核心理念 共益</div>
                  <div class="detail">
                    偶家科技作为共益企业，倡导商业向善，希望成为为了更加美好世界而存在的企业。偶家科技不断运用商业效力，为学龄前儿童打造一个更好的阅读新世界。
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </li>
      </ul>
    </div>
    <footer>
      <div class="fot-nav clean">
        <div class="main-one">
          <div class="top-l-img">
            <img :src="require(`../../../assets/footer/l-1.png`)" alt="">
            <img :src="require(`../../../assets/footer/l-2.png`)" alt="">
          </div>
          <div class="c-word">
            深圳市南山区招商街道沿山社区南海大道1077号北科创业大厦701
            <img
              :src="require(`../../../assets/footer/icon_address.png`)"
              alt=""
            >
          </div>
          <div class="c-word">
            联系电话:0755-82842710
            <img :src="require(`../../../assets/footer/icon_address.png`)" alt="">
          </div>
        </div>
        <div class="main-two">
          <div class="tip">偶家科技（小布壳）微信微博</div>
          <div class="contact-wrap">
            <div class="contact-item one">
              <img :src="require(`../../../assets/footer/xl.png`)" alt="">
              <div class="sub">
                <img :src="require(`../../../assets/footer/wb_qrcode.jpg`)" alt="">
              </div>
            </div>
            <div class="contact-item two">
              <img :src="require(`../../../assets/footer/wx.png`)" alt="">
              <div class="sub">
                <img :src="require(`../../../assets/footer/wx_qrcode.jpg`)" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="main-three">
          <ul>
            <li>
              <div class="title">推荐产品</div>
              <div class="item" @click="toQ1">小布壳Q1</div>
              <div class="item" @click="topicturebooks">精彩绘本</div>
            </li>
            <li>
              <div class="title">关于我们</div>
              <div class="item">关于偶家</div>
              <div class="item" @click="toJoin">加入我们</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="fot-copy">Copyright © 2020 xiaobuke. All Rights Reserved
        <br>粤ICP备16087044号-2
      </div>
    </footer>
    <el-backtop :bottom="100">
      <img :src="require(`../../../assets/index/go_top.jpg`)" alt="">
    </el-backtop>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "about",
  data() {
    return {
      currentNav: 2,
      isFixed: false,
      offsetTop: 0,
      currentxbk: 0
    };
  },
  methods: {
    toIndex() {
      this.$router.push({ path: "/" })     
    },
    toQ1() {
      this.$router.push({ path: "Q1" })
    },
    toBrand() {
      this.$router.push({ path: "brand" })
    },
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false
    },
    topicturebooks() {
      this.$router.push({ path: "picturebooks" })
    },
    toOJApp() {
      this.$router.push({ path: "OJApp" })
    },
    toAbout() {
      this.$router.push({ path: "about" })
    },
    toBootstrap(){
      this.$router.push({ path: "bootstrap" })
    },
    toJoin(){
      this.$router.push({ path: "join" })
    }
  },
  activated() {},
  mounted() {
    window.addEventListener("scroll", this.initHeight)
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector("#boxFixed").offsetTop
    })    
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss">
.page-about {
  width: 100%;
  header {
    width: 100%;
    height: 100px;
    background: #000;
    .wrap {
      max-width: 1200px;
      height: 100%;
      margin: auto;
      .logo-wrap {
        float: left;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 100%;
          max-height: 100%;
        }
      }
      ul {
        float: right;
        li {
          float: left;
          margin: 0 35px;
          line-height: 100px;
          position: relative;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          .line {
            width: 100%;
            height: 1px;
            background: #000;
            position: absolute;
            bottom: 20px;
            left: 0;
          }
          .child-box {
            display: none;
          }
        }
        li:last-child {
          margin-right: 0;
        }
        li.cur {
          color: #f95c57;
          .line {
            background: #f95c57;
            bottom: 30px;
            -webkit-transition: all 300ms ease 0s;
            transition: all 300ms ease 0s;
          }
        }
        li:hover {
          color: #f95c57;
          .child-box {
            display: block;
            width: 100px;
            background: #000;
            position: absolute;
            left: -24px;
            bottom: -72px;
            padding-bottom: 4px;
            z-index: 199;
            .item {
              width: 100%;
              height: 36px;
              color: #fff;
              text-align: center;
              line-height: 36px;
              font-size: 13px;
            }
            .item.one:hover {
              color: #f95c57;
            }
            .item.two:hover {
              color: #f95c57;
            }
          }
        }
        li:hover .line {
          background: #f95c57;
          bottom: 30px;
          -webkit-transition: all 300ms ease 0s;
          transition: all 300ms ease 0s;
        }
      }
    }
  }
  .box_fixed {
    width: 100%;
    height: 70px;
    background: #fff;
    .xbk-nav {
      max-width: 1200px;
      margin: auto;
      height: 100%;
      padding: 0;
      font-size: 14px;
      color: #333;
      .r {
        float: right;
        li {
          font-size: 13px;
          margin: 27px 0 0 35px;
          float: left;
          line-height: 24px;
          cursor: pointer;
        }
        li.cur {
          border-bottom: 1px solid #ff5001;
          color: #ff5001;
        }
        li:hover {
          border-bottom: 1px solid #ff5001;
          color: #ff5001;
        }
      }
    }
  }
  .is_fixed {
    position: fixed;
    top: 0;
    z-index: 999;
    -webkit-box-shadow: 0 0 9px #999;
    -moz-box-shadow: 0 0 9px #999;
    box-shadow: 0 0 9px #999;
  }
  .el-carousel__button {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #e9535e;
  }
  .main-wrap {
    background: #f4f5f7;
    .banner {
      font-size: 0;
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
    .about-wrap {
      max-width: 1200px;
      margin: auto;
      padding-bottom: 100px;
      li {
        position: relative;
        img{
          vertical-align: middle;
        }
        .w-inner {
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          justify-content: space-between;
          .word-w {
            width: 520px;
            padding: 90px 0 0 37px;
            .title {
              letter-spacing: 10px;
              font-size: 30px;
              padding-bottom: 40px;
            }
            .detail {
              font-size: 16px;
              line-height: 1.8;
              letter-spacing: 1px;          
            }
          }
          .img-w {
            width: 530px;
            overflow: hidden;
            font-size: 0;
            img {
              max-width: 100%;
            }
          }
        }
      }
      .w1 .w-inner{
        padding-top: 160px;
      }
      .w2 .w-inner{
        padding-top: 318px;
      }
      .w3 .w-inner{
        padding-top: 320px;
      }
      .w4{
        width: 100%;
        height: 400px;
        padding: 60px 0 30px;
        .wrap{
          width: 100%;
          height: 100%;
          display: flex;
          .img-w {
            width: 530px;
            overflow: hidden;
            font-size: 0;
            img {
              max-width: 100%;
            }
          }
          .word-w {
            width: 520px;
            padding: 90px 0 0 100px;
            .title {
              letter-spacing: 10px;
              font-size: 30px;
              padding-bottom: 40px;
            }
            .detail {
              font-size: 16px;
              line-height: 1.8;
              letter-spacing: 1px;          
            }
          }
          
        }
      }
    }
  }
  footer {
    width: 100%;
    height: 529px;
    background: #000;
    .fot-nav {
      max-width: 1200px;
      margin: auto;
      border-bottom: 1px solid #333;
      .main-one {
        float: left;
        padding: 50px 0;
        .top-l-img {
          font-size: 14px;
          img {
            margin-right: 19px;
          }
        }
        .c-word {
          padding-left: 30px;
          font-size: 15px;
          color: #fff;
          line-height: 24px;
          margin-top: 40px;
          position: relative;
          img {
            height: 24px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
      .main-two {
        float: right;
        padding: 80px 0;
        .tip {
          font-size: 15px;
          display: block;
          color: #fff;
          margin-bottom: 20px;
        }
        .contact-wrap {
          .contact-item {
            margin-left: 45px;
            padding-bottom: 20px;
            float: right;
            position: relative;
            font-size: 0;
            .sub {
              width: 180px;
              height: 180px;
              padding: 5px;
              background: #fff;
              position: absolute;
              left: 50%;
              margin-left: -95px;
              top: 100%;
              display: none;
              z-index: 99;
              img {
                vertical-align: middle;
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
          .contact-item.one:hover {
            .sub {
              display: block;
            }
          }
          .contact-item.two:hover {
            .sub {
              display: block;
            }
          }
        }
      }
      .main-three {
        float: right;
        ul {
          padding: 80px 0;
          li {
            margin-right: 110px;
            float: left;
            .title {
              font-size: 15px;
              display: block;
              color: #fff;
              margin-bottom: 20px;
            }
            .item {
              font-size: 14px;
              display: block;
              color: #b0b0b0;
              margin-bottom: 10px;
              line-height: 1.5;
            }
            .item:hover {
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
    }
    .clean:after {
      clear: both;
      content: "";
      display: block;
    }
    .fot-copy {
      padding: 50px 0 110px;
      line-height: 40px;
      font-size: 16px;
      color: #545454;
      text-align: center;
    }
  }
  .el-backtop {
    position: fixed;
    width: 70px;
    height: 70px;
    border-radius: 0;
    -webkit-box-shadow: 0 0 9px #999;
    box-shadow: 0 0 9px #999;
    cursor: pointer;
    z-index: 5;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
